import React from "react";
import "./App.css";

import Router from "./pages/router";
import { CustomProvider } from "rsuite";

function App() {


  return (
    <CustomProvider theme="light">
      <Router />
    </CustomProvider>
  );
}

export default App;
